import React from "react";
import { observer, inject } from "mobx-react";
import * as dateFns from "date-fns";
import SurveyEdit from "./survey-edit";
import SurveySettings from "./survey-settings";
import SurveyShare from "./survey-share";
import SurveyView from "./survey-view";
import SurveyList from "./survey-list";
import SurveyResults from "./survey-results";
import DateSelector from "./_common/date-selector";
import * as M from "@material-ui/core";

const SurveyContainer = props => {
  const { $survey, $router, $user, $group, $validation, $config } = props.store;

  const [educationLevel, setEducationLevel] = React.useState(0);

  React.useEffect(() => setEducationLevel($group.selected?.educationLevel || 0), [$group.selected]);

  const handleSubmitNew = async () => {
    let docRef = false;
    let validations = $validation.validateForm("new-survey");
    if (validations.size === 0) docRef = await $survey.selected.fsSave();
    $survey.setSelected(docRef.id);
    if (docRef) $router.push("/survey/edit/" + $survey.selected._key);
  };

  return $user.sessionUser.isVerifiedMentor ? (
    <React.Fragment>
      {!$survey.selected && (
        <header className="flex justify-between">
          <h2>
            {$survey.selected
              ? $survey.selected.name
              : `Beschikbare vragenlijst(en) ${
                  $group.selected && $user.sessionUser.isMentor && !$user.sessionUser.isCreator
                    ? "voor " + $group.selected.name
                    : ""
                }
                  `}
          </h2>
          {$config.id === "obs-barometer" && (
            <div>
              <M.TextField
                fullWidth
                name="educationLevel"
                select
                value={educationLevel}
                onChange={e => setEducationLevel(e.target.value)}
              >
                {[
                  { label: "Alle onderwijsniveau's", value: 0 },
                  { label: "Basisonderwijs", value: "basis" },
                  { label: "Secundair onderwijs", value: "secundair" }
                ].map((level, i) => (
                  <M.MenuItem key={i} value={level.value}>
                    {level.label}
                  </M.MenuItem>
                ))}
              </M.TextField>
            </div>
          )}
        </header>
      )}

      {$survey.selected && (
        <header className="flex justify-between">
          <div>
            <h2>{$survey.selected.name}</h2>
          </div>
          {($router.mode === "edit" || $router.mode === "settings") && (
            <div className="color-gray-light font-size-small right-align text-right">
              Laatst aangepast
              <br />
              door{" "}
              {$user.list.has($survey.selected.updatedBy)
                ? $user.list.get($survey.selected.updatedBy).email
                : $survey.selected.updatedBy}
              <br />
              op {dateFns.format($survey.selected.updatedOn, "dd/MM/yy HH:mm")}
            </div>
          )}
        </header>
      )}

      <div className="p-8">
        {$router.mode === "view" && <SurveyView {...props} />}
        {$router.mode === "edit" && <SurveyEdit />}
        {$router.mode === "settings" && <SurveySettings mode={$router.mode} />}
        {$router.mode === "share" && <SurveyShare />}
        {$router.mode === "results" && <SurveyResults />}
        {($router.mode === "new" || (!$router.mode && $survey.selected)) && (
          <M.Dialog open={$survey.selected} onClose={() => $router.push("/survey")}>
            <M.DialogTitle>Enquête toevoegen</M.DialogTitle>
            <M.DialogContent>
              <SurveySettings mode={"new"} />
            </M.DialogContent>
            <M.DialogActions>
              <M.Button variant="outlined" onClick={() => $router.push("/survey")}>
                Annuleren
              </M.Button>
              <M.Button onClick={handleSubmitNew} size="medium">
                Voeg toe
              </M.Button>
            </M.DialogActions>
          </M.Dialog>
        )}
        {(!$router.mode || $router.mode === "new") && (
          <SurveyList educationLevel={educationLevel} />
        )}
      </div>
    </React.Fragment>
  ) : (
    $survey.selected && (
      <div className="p-8">
        {$router.mode === "view" && <SurveyView {...props} />}
        {$router.mode === "results" && <SurveyResults {...props} />}
      </div>
    )
  );
};

export default inject("store")(observer(SurveyContainer));
